module.exports = __webpack_public_path__ + "static/images/pleated-blinds-video.mov";